import React, { RefObject, useRef, useState } from "react";
import styled from "styled-components";

import * as Document from "~/Document";
import * as Layout from "~/Layout";

export type Props = {
  readonly document: Document.Document;
};

const SIZE = 300;

export const Component: React.Fn<Props> = ({ document }) => {
  return (
    <>
      <Layout.Flex.Component row justify="flex-start">
        <div style={{ height: `${SIZE}px`, width: `${SIZE}px` }}>
          <BackgroundImage.Component document={document} size={SIZE} />
        </div>
        <Document.Detail.Description.Component
          document={document}
          onlyUniqueProperties={true}
        />
      </Layout.Flex.Component>
    </>
  );
};

export namespace BackgroundImage {
  export type Props = {
    readonly document: Document.Document;
    readonly size: number;
  };

  export const Component: React.Fn<Props> = ({ document, size }) => {
    const imageRef: RefObject<HTMLImageElement> = useRef(null);
    const [isError, setError] = useState(false);

    const onError = () => setError(true);
    const onLoad = () => setError(false);

    let url = "";
    if (document.images && document.images.length > 0) {
      url = document.images[0].imageUrl;
    }

    const BackgroundImage = styled.div`
      background: url("${url}");
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      height: ${size}px;
      width: ${size}px;
    `;

    return (
      <>
        <span style={{ display: "none" }}>
          <Document.Detail.Image.Component
            imageUrl={url}
            reference={imageRef}
            height={size}
            width={size}
            onLoad={onLoad}
            onError={onError}
          />
        </span>
        {isError ? (
          <Document.Detail.NotFound.Component size={SIZE} />
        ) : (
          <BackgroundImage />
        )}
      </>
    );
  };
}
